import { useState } from 'react';
import { useAppStore } from '../stores/useAppStore';
import './routes.css';

type Tab = 'stories' | 'universes';

export default function ArchiveRoute() {
  const stories = useAppStore((s) => s.stories);
  const universes = useAppStore((s) => s.universes);
  const unarchiveStory = useAppStore((s) => s.unarchiveStory);
  const unarchiveUniverse = useAppStore((s) => s.unarchiveUniverse);
  const [tab, setTab] = useState<Tab>('stories');

  const hiddenStories = Object.values(stories).filter((s) => s.hidden);
  const hiddenUniverses = Object.values(universes).filter((u) => u.hidden);

  return (
    <div className="route">
      <h1>Archive</h1>
      <div className="vibe-row">
        <button
          className={`vibe-pill ${tab === 'stories' ? 'active' : ''}`}
          onClick={() => setTab('stories')}
        >
          Stories ({hiddenStories.length})
        </button>
        <button
          className={`vibe-pill ${tab === 'universes' ? 'active' : ''}`}
          onClick={() => setTab('universes')}
        >
          Universes ({hiddenUniverses.length})
        </button>
      </div>

      {tab === 'stories' && (
        <>
          {hiddenStories.length === 0 && <div className="dim">Nothing archived.</div>}
          <div className="story-picker">
            {hiddenStories.map((story) => {
              const universe = universes[story.universeId];
              return (
                <div key={story.id} className="story-picker-row">
                  <div>
                    <div className="slug-title">{story.slug.title}</div>
                    {universe && <div className="dim small">{universe.name}</div>}
                    <div className="dim small">{story.slug.hook}</div>
                  </div>
                  <button onClick={() => unarchiveStory(story.id)}>Unarchive</button>
                </div>
              );
            })}
          </div>
        </>
      )}

      {tab === 'universes' && (
        <>
          {hiddenUniverses.length === 0 && <div className="dim">Nothing archived.</div>}
          <div className="story-picker">
            {hiddenUniverses.map((u) => (
              <div key={u.id} className="story-picker-row">
                <div>
                  <div className="slug-title">{u.name}</div>
                  {u.description && <div className="dim small">{u.description}</div>}
                </div>
                <button onClick={() => unarchiveUniverse(u.id)}>Unarchive</button>
              </div>
            ))}
          </div>
        </>
      )}
    </div>
  );
}
